module.exports = __webpack_public_path__ + "img/fizz.fdc667b8.jpg";